import React from 'react';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpFinishContact from 'components/molecules/SpFinishContact';

import { ADD_THANKS_TEXT } from 'utils/constant';

const PresentSP = ({
  onClickMainButton,
}) => (
  <div className="AddThanks SP">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
    >
      <span>
        <SpFinishContact
          info={ADD_THANKS_TEXT.information}
        />
      </span>
    </SpBasicTemplate>
  </div>
);  

export default PresentSP;